//#region ImportSection
import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Row,
  Table,
} from "reactstrap";
import { GetLanguageString, NoResult } from "../../helper/Components";
import moment from "moment";
import {
  applyClassToCharacters,
  convertUTCToLocalTime,
  isUrdu,
  LoadingSpinner,
} from "../../../constants/const";
import ApiSyllabusBook from "../../config/setupsyllabus/ApiSetupBook";
import { MdOutlineMenuBook } from "react-icons/md";
//#endregion ImportSection
const MemberBooks = ({ tab6, memberId }) => {
  //#region stateSection
  const [open, setOpen] = useState("");
  const [memberNisab, setmemberNisab] = useState([]);
  const [loading, setLoading] = useState(false);
  //#endregion stateSection
  //#region useEffectSection
  useEffect(() => {
    setLoading(true);

    if (tab6 === "active") {
      ApiSyllabusBook()
        .GetMemberNisaabBooks({ MemberId: memberId })
        .then((res) => {
          setmemberNisab(res.data);
        });
      setLoading(false);
    }
  }, [tab6, memberId, setLoading]);
  //#endregion useEffectSection
  //#region functionSection
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  //#endregion functionSection

  return (
    <>
      <div role="tabpanel" id="tab-6" className={"tab-pane " + tab6}>
        <div className="panel-body">
          {!loading ? (
            memberNisab?.length > 0 ? (
              <Row>
                <Col md="12">
                  {memberNisab?.map((item, index) => {
                    return (
                      <div key={index}>
                        <Accordion open={open} toggle={toggle} key={index}>
                          <AccordionItem>
                            <AccordionHeader targetId={(index + 1).toString()}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  width: "100%",
                                  gap: "12px",
                                }}
                              >
                                {/* Left — icon + title + subtitle */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    flex: 1,
                                    minWidth: 0,
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "45px",
                                      height: "45px",
                                      borderRadius: "8px",
                                      background: item.isCompleted
                                        ? "#E1F5EE"
                                        : "#fde3e3",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      flexShrink: 0,
                                    }}
                                  >
                                    <MdOutlineMenuBook
                                      style={{
                                        fontSize: "25px",
                                        color: item.isCompleted
                                          ? "#0F6E56"
                                          : "#850b0b",
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <div
                                      className={`${isUrdu(item.name) ? "ur" : ""}`}
                                      style={{
                                        fontSize: "15px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {item.name}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        color: "#888",
                                        marginTop: "2px",
                                      }}
                                    >
                                      {
                                        item.memberSyllabusBooks.filter(
                                          (b) => b.isReading,
                                        ).length
                                      }
                                      {" / "}
                                      {item.memberSyllabusBooks.length}{" "}
                                      <GetLanguageString props="settings_books" />
                                    </div>
                                  </div>
                                </div>

                                {/* Right — mini progress bar + status pill */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    flexShrink: 0,
                                    direction: "ltr",
                                  }}
                                >
                                  {(() => {
                                    const total =
                                      item.memberSyllabusBooks.length;
                                    const read =
                                      item.memberSyllabusBooks.filter(
                                        (b) => b.isReading,
                                      ).length;
                                    const percent =
                                      total > 0
                                        ? Math.round((read / total) * 100)
                                        : 0;
                                    const barColor =
                                      percent === 100
                                        ? "#0F6E56"
                                        : percent >= 50
                                          ? "#185FA5"
                                          : "#D97706";

                                    return (
                                      <div style={{ width: "80px" }}>
                                        <div
                                          style={{
                                            fontSize: "11px",
                                            color: barColor,
                                            marginBottom: "3px",
                                            textAlign: "right",
                                          }}
                                        >
                                          {percent}%
                                        </div>
                                        <div
                                          style={{
                                            background: "#dadbdb",
                                            borderRadius: "9999px",
                                            height: "5px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              width: `${percent}%`,
                                              background: barColor,
                                              height: "5px",
                                              borderRadius: "9999px",
                                              transition: "width 0.4s ease",
                                            }}
                                          />
                                        </div>
                                      </div>
                                    );
                                  })()}

                                  {item.isCompleted ? (
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        background: "#E1F5EE",
                                        color: "#0F6E56",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        padding: "3px 10px",
                                        borderRadius: "9999px",
                                      }}
                                    >
                                      ✔{" "}
                                      <GetLanguageString props="courses_status_completed" />
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        background: "#fcd2d2",
                                        color: "#850b0b",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        padding: "3px 10px",
                                        borderRadius: "9999px",
                                      }}
                                    >
                                      ⏳{" "}
                                      <GetLanguageString props="courses_status_incompleted" />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </AccordionHeader>
                            <AccordionBody accordionId={(index + 1).toString()}>
                              <div className="table-responsive">
                                <Table responsive>
                                  <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>
                                        <GetLanguageString props="syllabus_books_name" />
                                      </th>
                                      {item.specifyCompulsory ? (
                                        <th style={{ textAlign: "center" }}>
                                          <GetLanguageString props="common_type" />
                                        </th>
                                      ) : null}
                                      <th style={{ textAlign: "center" }}>
                                        <GetLanguageString props="dashboard_event_page_status" />
                                      </th>
                                      <th style={{ textAlign: "center" }}>
                                        <GetLanguageString props="read_at" />
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>{item.bookName}</tr>
                                    {item.memberSyllabusBooks.map(
                                      (record, index) => (
                                        <tr key={index}>
                                          <td>{index + 1}</td>
                                          <td>
                                            {applyClassToCharacters(
                                              record.syllabusBookName,
                                              "ur",
                                            )}
                                          </td>
                                          {item.specifyCompulsory ? (
                                            <td style={{ textAlign: "center" }}>
                                              {record.isCompulsory ? (
                                              <span
                                                style={{
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  gap: "3px",
                                                  background: "#EEEDFE",
                                                  color: "#3C3489",
                                                  fontSize: "11px",
                                                  fontWeight: "500",
                                                  padding: "2px 7px",
                                                  borderRadius: "4px",
                                                }}
                                              >
                                                ★{" "}
                                                <GetLanguageString props="syllabus_compulsory" />
                                              </span>
                                              ) : (
                                              <span
                                                style={{
                                                  background: "#F1EFE8",
                                                  color: "#5F5E5A",
                                                  fontSize: "11px",
                                                  fontWeight: "500",
                                                  padding: "2px 7px",
                                                  borderRadius: "4px",
                                                }}
                                              >
                                                <GetLanguageString props="syllabus_optional" />
                                              </span>
                                              )}
                                            </td>
                                          ) : null}
                                          <td style={{ textAlign: "center" }}>
                                            {record.isReading ? (
                                              <span
                                                style={{
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  gap: "4px",
                                                  background: "#E1F5EE",
                                                  color: "#0F6E56",
                                                  fontSize: "12px",
                                                  fontWeight: "500",
                                                  padding: "3px 10px",
                                                  borderRadius: "9999px",
                                                }}
                                              >
                                                <GetLanguageString props="book_read" />
                                              </span>
                                            ) : (
                                              <span
                                                style={{
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  gap: "4px",
                                                  background: "#fde3e3",
                                                  color: "#850b0b",
                                                  fontSize: "12px",
                                                  fontWeight: "500",
                                                  padding: "3px 10px",
                                                  borderRadius: "9999px",
                                                }}
                                              >
                                                <GetLanguageString props="book_not_read" />
                                              </span>
                                            )}
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "center",
                                              fontSize: "13px",
                                            }}
                                          >
                                            {record.isReading &&
                                            record.completedAt ? (
                                              moment(
                                                convertUTCToLocalTime(
                                                  record.completedAt,
                                                ),
                                              ).format("DD/MM/yyyy")
                                            ) : (
                                              <span style={{ color: "#aaa" }}>
                                                —
                                              </span>
                                            )}
                                          </td>
                                        </tr>
                                      ),
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </AccordionBody>
                          </AccordionItem>
                        </Accordion>
                      </div>
                    );
                  })}
                </Col>
              </Row>
            ) : (
              <NoResult />
            )
          ) : (
            LoadingSpinner()
          )}
        </div>
      </div>
    </>
  );
};

export default MemberBooks;
